export default __webpack_public_path__ + "8b5f16d58e7c13a6f6c8df84a7d10a7b.png";